import React, { useState, useEffect, useRef } from 'react';

const COACH_ROLES = [
  { value: '', label: 'Select a role...' },
  { value: 'head_coach', label: 'Head Coach' },
  { value: 'assistant_coach', label: 'Assistant Coach' },
  { value: 'tactical_analyst', label: 'Tactical Analyst' },
  { value: 'performance_analyst', label: 'Performance Analyst' },
  { value: 'scout', label: 'Scout' },
  { value: 'academy_coach', label: 'Academy Coach' },
  { value: 'director', label: 'Director of Football' },
];

const REGULATION_TYPES = [
  { value: 'professional', label: 'Professional' },
  { value: 'college_ncaa', label: 'College (NCAA)' },
  { value: 'college_naia', label: 'College (NAIA)' },
  { value: 'college_njcaa', label: 'College (NJCAA)' },
  { value: 'youth_academy', label: 'Youth Academy' },
  { value: 'semi_professional', label: 'Semi-Professional' },
];

const LEAGUES = {
  'Europe': [
    'Premier League (England)',
    'La Liga (Spain)',
    'Bundesliga (Germany)',
    'Serie A (Italy)',
    'Ligue 1 (France)',
    'Eredivisie (Netherlands)',
    'Primeira Liga (Portugal)',
    'Scottish Premiership',
    'Super Lig (Turkey)',
    'Russian Premier League',
    'Belgian Pro League',
    'Swiss Super League',
    'Austrian Bundesliga',
    'Danish Superliga',
    'Swedish Allsvenskan',
    'Norwegian Eliteserien',
    'Greek Super League',
    'Czech First League',
    'Polish Ekstraklasa',
    'Ukrainian Premier League',
    'Croatian First Football League',
    'Serbian SuperLiga',
  ],
  'South America': [
    'Brasileirao Serie A (Brazil)',
    'Argentine Primera Division',
    'Colombian Primera A',
    'Chilean Primera Division',
    'Uruguayan Primera Division',
    'Peruvian Primera Division',
    'Ecuadorian Serie A',
    'Venezuelan Primera Division',
    'Paraguayan Primera Division',
    'Bolivian Primera Division',
  ],
  'North/Central America': [
    'MLS (USA/Canada)',
    'Liga MX (Mexico)',
    'Costa Rican Primera Division',
    'Honduran Liga Nacional',
    'USL Championship (USA)',
    'NWSL (USA)',
    'Canadian Premier League',
  ],
  'Asia': [
    'Saudi Pro League',
    'J-League (Japan)',
    'K League (South Korea)',
    'Chinese Super League',
    'Indian Super League',
    'A-League (Australia)',
    'Thai League',
    'UAE Pro League',
    'Qatar Stars League',
    'Iraqi Premier League',
    'Iranian Pro League',
    'Uzbek Super League',
  ],
  'Africa': [
    'Egyptian Premier League',
    'South African Premier Division',
    'Moroccan Botola Pro',
    'Tunisian Ligue 1',
    'Nigerian NPFL',
    'Ghanaian Premier League',
    'Algerian Ligue 1',
    'Kenyan Premier League',
    'Tanzanian Premier League',
  ],
  'College (USA)': [
    'NCAA Division I',
    'NCAA Division II',
    'NCAA Division III',
    'NAIA',
    'NJCAA',
  ],
};

const styles = {
  card: {
    background: '#0f2040',
    border: '1px solid #1e3a5f',
    borderRadius: '12px',
    padding: '24px',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#f1f5f9',
    marginBottom: '6px',
  },
  sublabel: {
    fontSize: '12px',
    color: '#64748b',
    marginBottom: '8px',
    display: 'block',
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    background: '#0a1628',
    border: '1px solid #1e3a5f',
    borderRadius: '8px',
    color: '#f1f5f9',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.2s',
    boxSizing: 'border-box',
  },
  inputFocus: {
    borderColor: '#f59e0b',
  },
  inputReadonly: {
    width: '100%',
    padding: '10px 14px',
    background: '#0a1628',
    border: '1px solid #1e3a5f',
    borderRadius: '8px',
    color: '#64748b',
    fontSize: '14px',
    cursor: 'not-allowed',
    boxSizing: 'border-box',
  },
  select: {
    width: '100%',
    padding: '10px 14px',
    background: '#0a1628',
    border: '1px solid #1e3a5f',
    borderRadius: '8px',
    color: '#f1f5f9',
    fontSize: '14px',
    outline: 'none',
    cursor: 'pointer',
    appearance: 'none',
    boxSizing: 'border-box',
  },
  btnPrimary: {
    background: '#f59e0b',
    color: '#0a1628',
    fontWeight: '600',
    padding: '10px 24px',
    borderRadius: '8px',
    border: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  btnPrimaryDisabled: {
    background: '#f59e0b',
    color: '#0a1628',
    fontWeight: '600',
    padding: '10px 24px',
    borderRadius: '8px',
    border: 'none',
    fontSize: '14px',
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  fieldGroup: {
    marginBottom: '20px',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
  },
  logoPreview: {
    width: '80px',
    height: '80px',
    borderRadius: '12px',
    objectFit: 'cover',
    border: '2px solid #1e3a5f',
  },
  logoPlaceholder: {
    width: '80px',
    height: '80px',
    borderRadius: '12px',
    border: '2px dashed #1e3a5f',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#64748b',
    fontSize: '12px',
    cursor: 'pointer',
  },
  toggleContainer: {
    display: 'flex',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '1px solid #1e3a5f',
  },
  toggleBtn: {
    padding: '10px 20px',
    border: 'none',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    flex: 1,
    transition: 'all 0.2s',
    textAlign: 'center',
  },
  toggleActive: {
    background: '#f59e0b',
    color: '#0a1628',
  },
  toggleInactive: {
    background: '#0a1628',
    color: '#64748b',
  },
};

function ProfileInfoTab({ profile, onSave, saving }) {
  const [form, setForm] = useState({
    full_name: '',
    team_name: '',
    coach_role: '',
    league: '',
    preferred_language: 'en',
    regulation_type: 'professional',
  });
  const [leagueSearch, setLeagueSearch] = useState('');
  const [leagueDropdownOpen, setLeagueDropdownOpen] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [focusedField, setFocusedField] = useState(null);
  const leagueRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (profile) {
      setForm({
        full_name: profile.full_name || '',
        team_name: profile.team_name || '',
        coach_role: profile.coach_role || '',
        league: profile.league || '',
        preferred_language: profile.preferred_language || 'en',
        regulation_type: profile.regulation_type || 'professional',
      });
      if (profile.team_logo_url) {
        setLogoPreview(profile.team_logo_url);
      }
    }
  }, [profile]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (leagueRef.current && !leagueRef.current.contains(e.target)) {
        setLeagueDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleLogoSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      alert('File too large. Maximum size is 5MB.');
      return;
    }
    setLogoFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setLogoPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleLeagueSelect = (league) => {
    handleChange('league', league);
    setLeagueSearch('');
    setLeagueDropdownOpen(false);
  };

  const filteredLeagues = () => {
    const results = [];
    const search = leagueSearch.toLowerCase();
    Object.entries(LEAGUES).forEach(([region, leagues]) => {
      const filtered = leagues.filter(l => l.toLowerCase().includes(search));
      if (filtered.length > 0) {
        results.push({ region, leagues: filtered });
      }
    });
    return results;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form, logoFile);
  };

  const getInputStyle = (field) => {
    if (focusedField === field) {
      return { ...styles.input, ...styles.inputFocus };
    }
    return styles.input;
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={styles.card}>
        <h3 style={{ color: '#f1f5f9', fontSize: '18px', fontWeight: '700', marginBottom: '4px', marginTop: '0' }}>
          Coach Profile
        </h3>
        <p style={{ color: '#64748b', fontSize: '13px', marginBottom: '24px', marginTop: '0' }}>
          Your coaching identity and team information.
        </p>

        {/* Full Name */}
        <div style={styles.fieldGroup}>
          <label style={styles.label}>Full Name</label>
          <input
            type="text"
            value={form.full_name}
            onChange={(e) => handleChange('full_name', e.target.value)}
            onFocus={() => setFocusedField('full_name')}
            onBlur={() => setFocusedField(null)}
            style={getInputStyle('full_name')}
            placeholder="Enter your full name"
          />
        </div>

        {/* Email (read-only) */}
        <div style={styles.fieldGroup}>
          <label style={styles.label}>Email</label>
          <span style={styles.sublabel}>This is your login email and cannot be changed here.</span>
          <input
            type="email"
            value={profile?.email || ''}
            readOnly
            style={styles.inputReadonly}
          />
        </div>

        {/* Team Name + Logo Row */}
        <div style={{ ...styles.row, marginBottom: '20px' }}>
          <div>
            <label style={styles.label}>Team Name</label>
            <input
              type="text"
              value={form.team_name}
              onChange={(e) => handleChange('team_name', e.target.value)}
              onFocus={() => setFocusedField('team_name')}
              onBlur={() => setFocusedField(null)}
              style={getInputStyle('team_name')}
              placeholder="e.g. Al Hilal FC"
            />
          </div>
          <div>
            <label style={styles.label}>Team Logo</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              {logoPreview ? (
                <img src={logoPreview} alt="Team logo" style={styles.logoPreview} />
              ) : (
                <div
                  style={styles.logoPlaceholder}
                  onClick={() => fileInputRef.current?.click()}
                >
                  No logo
                </div>
              )}
              <div>
                <button
                  type="button"
                  onClick={() => fileInputRef.current?.click()}
                  style={{
                    background: 'transparent',
                    border: '1px solid #1e3a5f',
                    color: '#f1f5f9',
                    padding: '6px 14px',
                    borderRadius: '6px',
                    fontSize: '13px',
                    cursor: 'pointer',
                  }}
                >
                  {logoPreview ? 'Change' : 'Upload'}
                </button>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/png,image/jpeg,image/svg+xml,image/webp"
                  onChange={handleLogoSelect}
                  style={{ display: 'none' }}
                />
                <p style={{ color: '#64748b', fontSize: '11px', marginTop: '4px' }}>
                  PNG, JPG, SVG. Max 5MB.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Coach Role + Regulation Type Row */}
        <div style={{ ...styles.row, marginBottom: '20px' }}>
          <div>
            <label style={styles.label}>Coach Role</label>
            <div style={{ position: 'relative' }}>
              <select
                value={form.coach_role}
                onChange={(e) => handleChange('coach_role', e.target.value)}
                onFocus={() => setFocusedField('coach_role')}
                onBlur={() => setFocusedField(null)}
                style={focusedField === 'coach_role' ? { ...styles.select, borderColor: '#f59e0b' } : styles.select}
              >
                {COACH_ROLES.map(r => (
                  <option key={r.value} value={r.value} style={{ background: '#0a1628', color: '#f1f5f9' }}>
                    {r.label}
                  </option>
                ))}
              </select>
              <div style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#64748b' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </div>
            </div>
          </div>
          <div>
            <label style={styles.label}>Regulation Type</label>
            <div style={{ position: 'relative' }}>
              <select
                value={form.regulation_type}
                onChange={(e) => handleChange('regulation_type', e.target.value)}
                onFocus={() => setFocusedField('regulation_type')}
                onBlur={() => setFocusedField(null)}
                style={focusedField === 'regulation_type' ? { ...styles.select, borderColor: '#f59e0b' } : styles.select}
              >
                {REGULATION_TYPES.map(r => (
                  <option key={r.value} value={r.value} style={{ background: '#0a1628', color: '#f1f5f9' }}>
                    {r.label}
                  </option>
                ))}
              </select>
              <div style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#64748b' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* League (searchable) */}
        <div style={{ ...styles.fieldGroup, position: 'relative' }} ref={leagueRef}>
          <label style={styles.label}>League</label>
          <span style={styles.sublabel}>Search or browse by region.</span>
          <input
            type="text"
            value={leagueDropdownOpen ? leagueSearch : form.league}
            onChange={(e) => {
              setLeagueSearch(e.target.value);
              if (!leagueDropdownOpen) setLeagueDropdownOpen(true);
            }}
            onFocus={() => {
              setFocusedField('league');
              setLeagueDropdownOpen(true);
              setLeagueSearch('');
            }}
            onBlur={() => setFocusedField(null)}
            style={getInputStyle('league')}
            placeholder="Search leagues..."
          />
          {form.league && !leagueDropdownOpen && (
            <button
              type="button"
              onClick={() => handleChange('league', '')}
              style={{
                position: 'absolute',
                right: '12px',
                top: '58px',
                background: 'none',
                border: 'none',
                color: '#64748b',
                cursor: 'pointer',
                fontSize: '16px',
              }}
            >
              x
            </button>
          )}
          {leagueDropdownOpen && (
            <div
              style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                maxHeight: '280px',
                overflowY: 'auto',
                background: '#0f2040',
                border: '1px solid #1e3a5f',
                borderRadius: '8px',
                marginTop: '4px',
                zIndex: 50,
              }}
            >
              {filteredLeagues().length === 0 ? (
                <div style={{ padding: '12px 14px', color: '#64748b', fontSize: '13px' }}>
                  No leagues found.
                </div>
              ) : (
                filteredLeagues().map(group => (
                  <div key={group.region}>
                    <div style={{
                      padding: '8px 14px',
                      fontSize: '11px',
                      fontWeight: '700',
                      color: '#f59e0b',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      background: '#0a1628',
                      borderBottom: '1px solid #1e3a5f',
                      position: 'sticky',
                      top: 0,
                    }}>
                      {group.region}
                    </div>
                    {group.leagues.map(league => (
                      <div
                        key={league}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          handleLeagueSelect(league);
                        }}
                        style={{
                          padding: '8px 14px',
                          fontSize: '13px',
                          color: form.league === league ? '#f59e0b' : '#f1f5f9',
                          cursor: 'pointer',
                          borderBottom: '1px solid rgba(30, 58, 95, 0.3)',
                          background: form.league === league ? 'rgba(245, 158, 11, 0.08)' : 'transparent',
                        }}
                        onMouseEnter={(e) => { e.target.style.background = 'rgba(245, 158, 11, 0.08)'; }}
                        onMouseLeave={(e) => {
                          e.target.style.background = form.league === league ? 'rgba(245, 158, 11, 0.08)' : 'transparent';
                        }}
                      >
                        {league}
                        {form.league === league && (
                          <span style={{ float: 'right', color: '#f59e0b' }}>&#10003;</span>
                        )}
                      </div>
                    ))}
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        {/* Preferred Language */}
        <div style={styles.fieldGroup}>
          <label style={styles.label}>Preferred Language</label>
          <div style={styles.toggleContainer}>
            <button
              type="button"
              onClick={() => handleChange('preferred_language', 'en')}
              style={{
                ...styles.toggleBtn,
                ...(form.preferred_language === 'en' ? styles.toggleActive : styles.toggleInactive),
              }}
            >
              English
            </button>
            <button
              type="button"
              onClick={() => handleChange('preferred_language', 'ar')}
              style={{
                ...styles.toggleBtn,
                ...(form.preferred_language === 'ar' ? styles.toggleActive : styles.toggleInactive),
              }}
            >
              &#1593;&#1585;&#1576;&#1610; (Arabic)
            </button>
          </div>
        </div>

        {/* Save Button */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '28px' }}>
          <button
            type="submit"
            disabled={saving}
            style={saving ? styles.btnPrimaryDisabled : styles.btnPrimary}
          >
            {saving ? 'Saving...' : 'Save Profile'}
          </button>
        </div>
      </div>
    </form>
  );
}

export default ProfileInfoTab;
